import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { HospitalsComponent } from './hospitals/hospitals.component';
import { HospitalDetailComponent } from './hospital-detail/hospital-detail.component';
import { HospitalListComponent } from './hospital-list/hospital-list.component';
import { PartnerPagesRoutingModule } from './partnerpages-routing.module';
import { DoctorsComponent } from './doctors/doctors.component';
import { DoctorListComponent } from './doctor-list/doctor-list.component';
import { DoctorDetailComponent } from './doctor-detail/doctor-detail.component';
import { PharmaciesComponent } from './pharmacies/pharmacies.component';
import { PharmacyListComponent } from './pharmacy-list/pharmacy-list.component';
import { PharmacyDetailComponent } from './pharmacy-detail/pharmacy-detail.component';
import { LabsComponent } from './labs/labs.component';
import { LabDetailComponent } from './lab-detail/lab-detail.component';
import { LabListComponent } from './lab-list/lab-list.component';
import { HospitalDoctorDetailComponent } from './hospital-doctor-detail/hospital-doctor-detail.component';
import { HeadersearchComponent } from './headersearch/headersearch.component';
import { HeaderComponent } from './header/header.component';
import { AuthService } from '../services/auth.service';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { DateTimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ReadMoreDirective } from '../see-more/see-more.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { PartnerModule } from '../partner/partner.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { LandingComponent } from '../landing/landing.component';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { TranslateModule } from '@ngx-translate/core';
// Replacements
import { Ng2TelInputModule } from '../shared/ng2-tel-compat/ng2-tel-input.module';
import { SlideshowModule } from '../shared/slideshow/slideshow.module';

@NgModule({
  declarations: [
    LandingComponent,
    HospitalsComponent,
    HospitalDetailComponent,
    HospitalListComponent,
    DoctorsComponent,
    DoctorListComponent,
    DoctorDetailComponent,
    PharmaciesComponent,
    PharmacyListComponent,
    PharmacyDetailComponent,
    LabsComponent,
    LabDetailComponent,
    LabListComponent,
    HospitalDoctorDetailComponent,
    HeadersearchComponent,
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    PartnerPagesRoutingModule,
    PartnerModule,
    GooglePlaceModule,
    SlickCarouselModule,
    InfiniteScrollModule,
    DateTimePickerModule,
    SlideshowModule,
    BsDatepickerModule,
    TimepickerModule,
    Ng2TelInputModule,
    NgxSpinnerModule,
    AutocompleteLibModule,
    TranslateModule,
  ],
  exports: [
    HeaderComponent,
    LandingComponent,
    HeadersearchComponent,
  ],
})
export class PartnerPagesModule { }
